export const EVENTS = {
  TRACK_ACTION: 'trackAction',
  PAGE_VIEW: 'pageView',
  UPDATE_ZIP: 'updateZip',
  UPDATE_GTM_VEHICLE: 'updateGtmVehicle',
};
